import api from '../api'

const baseUrl = '/wallet/api'

const dadbananWallet = {
  getAllBalanceInformation() {
    return api.get(`${baseUrl}/AdminCoin/AllBalanceV2`)
  },
  UserTransactions(params) {
    return api.post(`${baseUrl}/Transaction/TransactionsEachUser`, params)
  },
  updateManualPayment(params) {
    return api.post(`${baseUrl}/Transaction/UpdateManualPayment/${params.id}`, params)
  },
  updateManualPaymentStatus(params) {
    return api.post(`${baseUrl}/Transaction/UpdateManualPaymentStatus/${params.id}`, params)
  },
  addUsersExcel(params) {
    return api.post(`${baseUrl}/people/DetectExistPeoples`, params)
  },
  chargeWalletWithTransferAdmin(params) {
    return api.post(`${baseUrl}/PrePurchaseInformation/ChargeWalletWithTransferFromAdmin`, params)
  },
}

export default dadbananWallet
